import { render, staticRenderFns } from "./ModalProjectUserRemove.vue?vue&type=template&id=72b3731a&lang=pug"
import script from "./ModalProjectUserRemove.vue?vue&type=script&lang=js"
export * from "./ModalProjectUserRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports